import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

// Store modules
import config from './config'
import intro from './intro'
import auth from './auth'
import campaign from './campaign'
import leaderboard from './leaderboard'
import gallery from './gallery'
import session from './session'
import sidebar from './sidebar'
import toast from './toast'
import api from './api'
import modals from './modals'

// Add Vuex to Vue
Vue.use(Vuex)

// Persist auth to localStorage
const VuexLocal = new VuexPersist({
	storage: window.sessionStorage,
	reducer: state => ({ auth: state.auth })
})

export default new Vuex.Store({
	modules: {
		config,
		intro,
		auth,
		campaign,
		leaderboard,
		gallery,
		session,
		sidebar,
		toast,
		api,
		modals
	},
	plugins: [VuexLocal.plugin]
})
